// Store references to event handlers and elements for cleanup
let createPageCancelBtn: Element | null = null;
let createPageButtons: NodeListOf<Element> | null = null;
let createPageBtn: Element | null = null;

const setStyle = function (e) {
    var loader = document.querySelector('#CreatePageDialog .loader-wrapper') as HTMLElement;
    loader.style.display = 'flex';
};

const closeDialog = function (e) {
  e.preventDefault();
  var createPageDialog = document.getElementById('CreatePageDialog');
  createPageDialog.style.display = 'none';
};

const showCreatePageModal = function (e) {
  e.preventDefault();
  var createPageDialog = document.getElementById('CreatePageDialog');
  createPageDialog.style.display = 'flex';
};


const init = function () {
  createPageCancelBtn = document.querySelector('#createPageCancelBtn');
  createPageCancelBtn?.addEventListener('click', closeDialog);

  createPageButtons = document.querySelectorAll('.create-page-button');
  createPageButtons?.forEach((el) => el.addEventListener('click', showCreatePageModal));

  createPageBtn = document.querySelector('#CreatePageBtn');
  createPageBtn?.addEventListener('click', setStyle);
};

const cleanup = function () {
  createPageCancelBtn?.removeEventListener('click', closeDialog);
  
  createPageButtons?.forEach((el) => el.removeEventListener('click', showCreatePageModal));
  
  createPageBtn?.removeEventListener('click', setStyle);
  
  // Clear references
  createPageCancelBtn = null;
  createPageButtons = null;
  createPageBtn = null;
};

document.addEventListener('DOMContentLoaded', init);
window.addEventListener('beforeunload', cleanup);